import React from 'react'

const Ellipse = () => (
  <svg width="33" height="33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.333" cy="16.889" r="16" fill="#CECECE" />
  </svg>
)

export default Ellipse
